import http from '@/utils/http'
import { PATH_SSO, PATH_USER_CENTER } from '@/utils/consts'
import { UserReq, LearnReq, WxLoginReq, SmsLoginReq, SendSmsReq } from './types/user'

const APP_ID = 'SCCHI'

export const loginByWx = (data: WxLoginReq) => {
  return http.post(`${PATH_SSO}/permit/v1/wx/login`, data)
}

export const loginBySms = (data: SmsLoginReq) => {
  return http.post(`${PATH_SSO}/permit/v1/sms/login`, data)
}

export const sendSms = (data: SendSmsReq) => {
  return http.post(`${PATH_SSO}/permit/v1/vercode`, data)
}

export const logout = () => {
  return http.post(`${PATH_SSO}/v1/logout`)
}

export const deleteUser = () => {
  return http.post(`${PATH_SSO}/v1/user/unregister`, { app_id: APP_ID })
}

export const getUserInfo = () => {
  return http.get(`${PATH_USER_CENTER}/v2/users/me`)
}

export const createUser = (data: UserReq) => {
  return http.post(`${PATH_USER_CENTER}/v2/users/me`, data)
}

export const updateUserInfo = (data: UserReq) => {
  return http.put(`${PATH_USER_CENTER}/v2/users/me`, data)
}

export const getNewFunctionAccess = () => {
  return http.get(`${PATH_USER_CENTER}/v2/users/newFunctionAccessRecord`)
}

export const invite = (params: { groupId: string; name?: string; faceId?: string }) => {
  return http.post(`${PATH_USER_CENTER}/v2/players/invite`, params)
}

export const getInvitedCode = () => {
  return http.get(`${PATH_USER_CENTER}/v2/invitation/code`)
}

export const postFeedback = (data: { issueType: number; description: string }) => {
  return http.post(`${PATH_USER_CENTER}/v2/feedbacks`, data)
}

// 学习进度
export const getUserCourseLearn = (data: LearnReq) => {
  return http.get(`${PATH_USER_CENTER}/v2/business/player/edu/record`, data)
}

export const getUrlLink = () => {
  return http.get(`${PATH_SSO}/permit/wx/v1/url-link `)
}
